import React from 'react'

interface SupportAgentData {
  name: string
  avatar?: string
}

// Presentational only — agent identity is derived inside SupportChatAssistant.
export default function SupportAgent({ content, blockType }: { content: string; blockType?: string }) {
  const agentData = React.useMemo<SupportAgentData | null>(() => {
    try {
      const trimmedContent = content.trim()
      if (trimmedContent === 'null') {
        return null
      }
      const validJson = trimmedContent
        .replace(/^{'/g, '{"')
        .replace(/'}/g, '"}')
        .replace(/':\s*'/g, '": "')
        .replace(/',\s*'/g, '", "')
      return JSON.parse(validJson) as SupportAgentData | null
    } catch {
      return null
    }
  }, [content])

  const isLegacyAgentLeft = React.useMemo(() => content.trim() === 'null', [content])

  if (agentData === null && !isLegacyAgentLeft) {
    return null
  }

  const name = agentData?.name || 'Agent'

  if (isLegacyAgentLeft) {
    return (
      <span>
        <strong>{name}</strong> left the chat
      </span>
    )
  }

  // Backend prepends the human-readable line to message.text; block renders nothing.
  switch (blockType) {
    case 'support_agent_left':
    case 'support_agent_reassigned':
    case 'support_agent_assigned':
    case 'support_agent':
    default:
      return null
  }
}
